//#region src/assets/email-verification-icon.svg
var email_verification_icon_default = "" + new URL("email-verification-icon-BS3Bkkz-.svg", import.meta.url).href;
//#endregion
export { email_verification_icon_default as default };

//# sourceMappingURL=email-verification-icon.js.map